import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/lib/site";

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 md:py-32 bg-brand-ink"
    >
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-brand-gold/90">
          <span className="inline-block h-px w-10 bg-brand-gold" />
          Frequently asked
        </div>
        <h2 className="mt-4 font-serif text-4xl md:text-6xl text-white leading-tight max-w-3xl text-balance">
          Answers, before you{" "}
          <span className="text-brand-gold italic">ask</span>.
        </h2>

        <Accordion
          type="single"
          collapsible
          className="mt-12 divide-y divide-white/5 border-y border-white/5"
          data-testid="faq-accordion"
        >
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-0"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left font-serif text-lg md:text-2xl text-white hover:text-brand-gold py-6 [&[data-state=open]]:text-brand-gold">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/75 text-base md:text-lg leading-relaxed pb-8 max-w-3xl">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
